export default {
  navigationDrawer: true,
  exporters: [],
  timePeriods: [],
  account: {
    id: null,
    company_name: "",
    icegate_id: "",
    cha_license_number: ""
  }
};
